import { createRequest } from "helpers/tools";

export const deleteConnection = async (id) => {
    return await createRequest({
        suffix: `lead/connection/${id}`,
        method: "delete",
        handleError: false,
    });
};
export const deleteFieldMapping = async (connection_id, field_mapping_id, data) => {
    return await createRequest({
        suffix: `lead/connection/${connection_id}/field-mapping/${field_mapping_id}/remove`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
export const editConnection = async (data, id) => {
    return await createRequest({
        suffix: `lead/connection/${id}`,
        method: "put",
        payload: data,
        handleError: false,
    });
};

export const getSourceApiDocument = async (id) => {
    return await createRequest({
        suffix: `lead/source-api/${id}/document`,
        method: "get",
        handleError: false,
    });
};
